import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcPlugin from '../components/calc/plisse/CalcPlugin.svelte';
import PlisseCalcCommon from '../components/calc/plisse/CalcCommon.svelte';
import PlisseCalcRazdvijka from '../components/calc/plisse/CalcRazdvijka.svelte';
import PlisseCalcPlisse16 from '../components/calc/plisse/CalcPlisse16.svelte';
import PlisseCalcO2 from '../components/calc/plisse/CalcO2.svelte';
import AdamCalcSoft from '../components/calc/adam/CalcSoft.svelte';
import AdamCalcSlaydors4 from '../components/calc/adam/CalcSlaydors4.svelte';
import PlisseCalcSmart from "../components/calc/plisse/CalcSmart.svelte";
import PlisseCalcSlim from "../components/calc/plisse/CalcSlim.svelte";
import PlisseCalc42DV from '../components/calc/plisse/Calc42DV.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import PartPrice from '../components/parts/Price.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import AdamCalcMounting from '../components/calc/adam/CalcMounting.svelte';
import CalcZanzar from '../components/calc/adam/CalcZanzar.svelte';
import AdamCalcSlaydorsGluh from '../components/calc/adam/CalcSlaydorsGluh.svelte';
import AdamCalcSlaydors6 from '../components/calc/adam/CalcSlaydors6.svelte';
import AdamCalcSlaydorsGiliatina from '../components/calc/adam/CalcSlaydorsGiliatina.svelte';
import CalcMayatnik from '../components/calc/adam/CalcMayatnik.svelte';
import CalcPodokonnik from '../components/calc/adam/CalcPodokonnik.svelte';
import CalcRilly from '../components/calc/adam/CalcRilly.svelte';
import CalcUSN from '../components/calc/plisse/CalcUSN.svelte';

let list = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'axis-one') {
    logo = 'axis.png';
    precision = 1;
    
    list.push({
        title: 'Плиссе',
        calc: 'Плиссе',
        img: '/img/plisse/axis-plisse/plisse.jpg,/img/plisse/axis-plisse/plisse2.jpg,/img/plisse/axis-plisse/plisse3.jpg,/img/plisse/axis-plisse/plisse4.jpg,/img/plisse/axis-plisse/plisse5.jpg,/img/plisse/axis-plisse/plisse6.jpg,/img/plisse/axis-plisse/plisse7.jpg,/img/plisse/axis-plisse/plisse8.jpg',
        description: 'Плиссированная сетка со складками шириной 25мм. Профиль: 40-30 мм. Максимальные размеры ширина 6 м. и высота 3м.',
        link: 'плиссе',
        component: PlisseCalcPlisse,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });
    
    list.push({
        title: 'SlimPro',
        calc: 'SlimPro',
        img: '/img/plisse/axis-plisse/slimpro.jpeg,/img/plisse/axis-plisse/slimpro2.jpg,/img/plisse/axis-plisse/slimpro3.jpg,/img/plisse/axis-plisse/slimpro4.jpg',
        description: 'Плиссе для средних размера проемов. Профиль: 25-25 мм. Ширина волны сетки: 14-16 мм',
        link: 'slimpro',
        component: PlisseCalcSlimPro,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });
    
    list.push({
        title: 'Smart',
        calc: 'Smart',
        img: '/img/plisse/axis-plisse/smart.jpg,/img/plisse/axis-plisse/smart2.jpg,/img/plisse/axis-plisse/smart3.jpg,/img/plisse/axis-plisse/smart4.jpg,/img/plisse/axis-plisse/smart5.jpg',
        description: 'Плиссе для средних размера проемов. Профиль: 40-27 мм. Ширина волны сетки:  16 мм',
        link: 'smart',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            }
        }
    });
    
    list.push({
        title: 'Москитная система Slim',
        calc: 'Slim',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'slim',
        component: PlisseCalcSlim,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 2100,
                height: 2200
            }
        }
    });
    
    list.push({
        title: 'Вставная сетка',
        calc: 'Вставная',
        img: '/img/plisse/plugin.jpg',
        description: 'Легкая и быстрая установка подходит для оконного фильтра',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            PartMaterials,

        ],
    });
    
    list.push({
        title: 'Рамочная сетка',
        calc: 'Обычная',
        img: '/img/plisse/common.jpg',
        description: 'Рамочная москитная сетка на кронштейнах или крючках',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });
    
    list.push({
        title: 'Plisse.ltd 16',
        calc: 'Плиссе 16мм',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 16мм. Максимальные размеры ширина 3 м. и высота 2.5м',
        link: 'плиссе-16',
        component: PlisseCalcPlisse16,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });
    
    list.push({
        title: 'Защита нового поколения О2',
        calc: 'Детская',
        img: '/img/plisse/o2.jpeg',
        description: 'Прозрачные решетки (ламели) защитят от выпадения ребенка',
        link: 'защита-о2',
        component: PlisseCalcO2,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });
    
    list.push({
        title: 'Мягкие окна',
        calc: 'Мягкие',
        img: '/img/мягкие-окна.jpg',
        description: 'Гибкие окна, прозрачные шторы ПВХ для беседок, террас, веранд, балконов',
        link: 'мягкие-окна',
        component: AdamCalcSoft,
        components: [
            PartPrice,
            AdamCalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Система Слайдорс 4',
        calc: 'Слайдорс 4', // Cлайдорс 4
        img: '/img/slaydors/razdvizhnoe-osteklenie-sistema-panorama.jpg',
        description: 'Система Слайдорс 4 - безрамное остекление',
        link: 'слайдорс-4',
        component: AdamCalcSlaydors4,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 30000,
                height: 4000,
            },
            recomend: {
                width: 20000,
                height: 3000,
            },
        }
    });

    list.push({
        title: 'Система Слайдорс 6',
        calc: 'Слайдорс 6', // Cлайдорс 6
        img: '/img/slaydors/razdvizhnoe-osteklenie-sistema-panorama.jpg',
        description: 'Система Слайдорс 6 - безрамное остекление',
        link: 'слайдорс-6',
        component: AdamCalcSlaydors6,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 50000,
                height: 5000,
            },
            recomend: {
                width: 30000,
                height: 3000,
            },
        }
    });

    list.push({
        title: 'Система Гильотина',
        calc: 'Гильотина',
        img: '/img/slaydors/gilotinnoe-osteklenie.jpg',
        description: 'Остекление системой Гильотина',
        link: 'система-гильотина',
        component: AdamCalcSlaydorsGiliatina,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Система глухое остекление',
        calc: 'Cлайдорс глух.',
        img: '/img/slaydors/gluhsteklo.jpeg',
        description: 'Глухое остекление в системе Слайдорс',
        link: 'слайдорс-глух',
        component: AdamCalcSlaydorsGluh,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Раздвижная Проведал',
        calc: 'Раздвижка',
        img: '/img/PROVEDAL.jpg',
        description: 'Сдвижная противомоскитная сетка устанавливается с внутренней и внешней стороны на верхних и нижних направляющих.',
        link: 'раздвижка-проведал',
        component: PlisseCalcRazdvijka,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Дверная рамочная сетка',
        calc: 'Дверная',
        img: '/img/plisse/common.jpg',
        description: 'Дверная рамочная сетка 42 профиль',
        link: 'дверная-42профиль',
        component: PlisseCalc42DV,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            }
        }

    });


    list.push({
        title: 'Москитная система ZANZAR',
        calc: 'ZANZAR',
        img: '/img/zanzar.jpg',
        description: 'Рулонная москитная сетка с боковыми направляющими',
        link: 'zanzar',
        component: CalcZanzar,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 1600,
                height: 2400
            },
            recomend: {
                width: 1600,
                height: 2400

            },

        }
    });


    list.push({
        title: 'Цельностеклянная дверь',
        calc: 'Цельностеклянные двери',
        img: '/img/mayatnik/pict.jpg',
        description: 'Маятниковая система цельностеклянные двери',
        link: 'Цельностеклянная дверь',
        component: CalcMayatnik,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 10000,
                height: 5000
            },
            recomend: {
                width: 10000,
                height: 5000

            },

        }
    });


    list.push({
        title: 'Подоконники',
        calc: 'Подоконник',
        img: '/img/podokonnik.jpg',
        description: 'Подоконники разных видов',
        link: 'Подоконник',
        component: CalcPodokonnik,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 10000,
                height: 4000
            },
            recomend: {
                width: 10000,
                height: 5000

            },

        }
    });

    list.push({
        title: 'Rilly',
        calc: 'Rilly',
        img: '/img/logo/Logo_Rilly.svg',
        description: 'Губки для мытья',
        link: 'Rilly',
        component: CalcRilly,
        components: [
            PartPrice,
            PartMaterials,
        ],

    });

    list.push({
        title: 'Сетка USN',
        calc: 'USN',
        img: '/img/plisse/usn.mp4',
        description: 'Сетка USN',
        link: 'usn',
        component: CalcUSN,
        components: [
            PartPrice,
            PartMaterials,
        ],

    });



}

export {list, logo, precision};
